export default "__VITE_ASSET__5bc44e69__"